import styled from 'styled-components';

export const DeveloperToolsCardsStyled = styled.div`
  display: flex;
  padding: 0em 1em 1em 1em;
  flex-direction: column;
  align-items: flex-start;
  gap: 1em;
  flex: 1 0 0;
  align-self: stretch;
`;

export const DeveloperToolsCardStyled = styled.div`
  display: flex;
  padding: 1em;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;

  border-radius: 0.1875em;
  background: var(--color-background-surface, #fff);
  font-size: 0.875em;
  line-height: 1.5em; /* 171.429% */
  font-style: normal;
  font-weight: 700;

  /* Shadow/Depth 1 */
  box-shadow:
    0px 0px 1px 0px rgba(0, 0, 0, 0.15),
    0px 1px 3px 0px rgba(0, 0, 0, 0.12),
    0px 1px 6px 0px rgba(0, 0, 0, 0.05);

  .heading {
    display: flex;
    padding-bottom: 0.5em;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;

    .title {
      color: var(--color-neutral-70, #444);
    }
    .description {
      color: var(--color-neutral-70, #444);
      font-weight: 400;
      padding-right: 1.5em;
    }
  }

  .action {
    display: flex;
    align-items: center;
    align-self: stretch;
    width: 100%;
    gap: 0.75em;

    .done {
      display: flex;
      align-items: center;
      gap: 0.25em;
      align-self: stretch;

      div:first-child {
        background: var(--color-teal, #00857e);
        border-radius: 50%;
        width: 1.5em;
        height: 1.5em;

        svg {
          width: 1.5em;
          height: 1.5em;
        }
      }

      .description {
        color: var(--color-neutral-70, #444);
        font-weight: 400;
      }
    }

    button {
      display: flex;
      padding: 0.5em 0.75em;
      justify-content: center;
      align-items: center;
      align-self: stretch;
      border-radius: 0.1875em;
      border: 2px solid var(--color-border-mid-contrast, #dbdbdb);
      background: var(--color-background-action-secondary-base, #fff);

      color: var(--color-text-high-contrast, #444);
      text-align: center;
      position: relative;

      &:hover {
        background: var(--color-neutral-20, #f0f0f0);
      }
      &:active {
        border: 2px solid var(--color-border-high-contrast, #949494);
      }
      &:focus {
        .focus-ring {
          border: 2px solid var(--a11y);
          border-radius: 0.1875em;
        }
      }

      .focus-ring {
        position: absolute;
        width: calc(100% + 0.75em);
        height: 3.25em;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
`;
